<section class="section-title">

    <div *ngIf="canUserEditAlias" class="buttons-container">
        <a (click)="unlinkOwner()" class="button button-red">
            <ng-container i18n="@@aliasdetail_unlink">Scollega operatore</ng-container> <span><fa-icon
                    icon="unlink"></fa-icon></span>
        </a>
    </div>

    <div class="section-title-image">
        <img class="alias-image" src="assets/img/alias.png" />
    </div>

    <div class="section-title-text">
        <h1>{{ alias?.displayName }}</h1>

        <p>
            <ng-container i18n="@@aliasdetail_email">Email:</ng-container> {{alias?.email}} <br />
            <ng-container i18n="@@aliasdetail_uid">ID:</ng-container> {{alias?.uid}} <br />
        </p>

    </div>

</section>

<section>

    <div>
        <h2 class="margin-top-20" i18n="@@aliasdetail_alias_details">Dettagli operatore</h2>

        <br>

        <table class="simple-table">
            <tr>
                <td height="80px" class="text-dark td-title" i18n="@@aliasdetail_alias_display_name">Nome
                    visualizzato</td>
                <ng-container *ngIf="canUserEditAlias">
                    <td>
                        <input [(ngModel)]="publicName" />
                    </td>
                </ng-container>
                <ng-container *ngIf="!canUserEditAlias">
                    <td>
                        <label class="td-label">{{publicName}}</label>
                    </td>
                </ng-container>
            </tr>
        </table>

    </div>


    <div id="alias-permissions">

        <h2 class="margin-top-20" i18n="@@aliasdetail_permissions_management">Gestione permessi</h2>

        <form class="margin-top-20" [formGroup]="aliasPermissionsForm">
            <table class="simple-table">

                <tr class="category-header">
                    <td colspan="2" class="text-bold" i18n="@@aliasdetail_category_devices">Dispositivi</td>
                </tr>

                <tr class="radioButtonTr">
                    <td class="text-dark td-title" i18n="@@aliasdetail_device_view_permissions">Visione dispositivi :
                    </td>
                    <td class="radioButton">
                        <ng-container i18n="@@Enable">Abilita</ng-container>
                        <div id="radioButtonDiv">
                            <label class="radioButtonLabel">
                                <input type="radio" formControlName="DeviceViewForm" [(ngModel)]="DeviceView"
                                    name="DeviceViewForm" value="true" (change)="onRadioButtonClickViewDevices(true)"
                                    [attr.disabled]="!canUserEditAlias ? true : null">
                            </label>
                        </div>
                        <ng-container i18n="@@Disable">Disabilita</ng-container>
                        <div id="radioButtonDiv">
                            <label class="radioButtonLabel">
                                <input type="radio" formControlName="DeviceViewForm" [(ngModel)]="DeviceView"
                                    name="DeviceViewForm" value="false" (change)="onRadioButtonClickViewDevices(false)"
                                    [attr.disabled]="!canUserEditAlias ? true : null">
                            </label>
                        </div>
                    </td>
                </tr>

                <tr class="radioButtonTr">
                    <td class="text-dark td-title" i18n="@@aliasdetail_device_edit_permissions">Modifica dispositivi :
                    </td>
                    <td class="radioButton">
                        <ng-container i18n="@@Enable">Abilita</ng-container>
                        <div id="radioButtonDiv">
                            <label class="radioButtonLabel">
                                <input type="radio" formControlName="DeviceEditForm" [(ngModel)]="DeviceEdit"
                                    name="DeviceEditForm" value="true" (change)="onRadioButtonClickEditDevices(true)"
                                    [attr.disabled]="!canUserEditAlias ? true : null">
                            </label>
                        </div>
                        <ng-container i18n="@@Disable">Disabilita</ng-container>
                        <div id="radioButtonDiv">
                            <label class="radioButtonLabel">
                                <input type="radio" formControlName="DeviceEditForm" [(ngModel)]="DeviceEdit"
                                    name="DeviceEditForm" value="false" (change)="onRadioButtonClickEditDevices(false)"
                                    [attr.disabled]="!canUserEditAlias ? true : null">
                            </label>
                        </div>
                    </td>
                </tr>

                <tr class="radioButtonTr">
                    <td class="text-dark td-title" i18n="@@aliasdetail_devide_action_permissions">Azionamento
                        dispositivi :</td>
                    <td class="radioButton">
                        <ng-container i18n="@@Enable">Abilita</ng-container>
                        <div id="radioButtonDiv">
                            <label class="radioButtonLabel">
                                <input type="radio" formControlName="DeviceActionForm" [(ngModel)]="DeviceAction"
                                    name="DeviceActionForm" value="true"
                                    (change)="onRadioButtonClickActionDevices(true)"
                                    [attr.disabled]="!canUserEditAlias ? true : null">
                            </label>
                        </div>
                        <ng-container i18n="@@Disable">Disabilita</ng-container>
                        <div id="radioButtonDiv">
                            <label class="radioButtonLabel">
                                <input type="radio" formControlName="DeviceActionForm" [(ngModel)]="DeviceAction"
                                    name="DeviceActionForm" value="false"
                                    (change)="onRadioButtonClickActionDevices(false)"
                                    [attr.disabled]="!canUserEditAlias ? true : null">
                            </label>
                        </div>
                    </td>
                </tr>

                <tr class="radioButtonTr">
                    <td class="text-dark td-title" i18n="@@aliasdetail_devide_reboot_permissions">Riavvio dispositivi :
                    </td>
                    <td class="radioButton">
                        <ng-container i18n="@@Enable">Abilita</ng-container>
                        <div id="radioButtonDiv">
                            <label class="radioButtonLabel">
                                <input type="radio" formControlName="DeviceRebootForm" [(ngModel)]="DeviceReboot"
                                    name="DeviceReboot" value="true" (change)="onRadioButtonClickRebootDevices(true)"
                                    [attr.disabled]="!canUserEditAlias ? true : null">
                            </label>
                        </div>
                        <ng-container i18n="@@Disable">Disabilita</ng-container>
                        <div id="radioButtonDiv">
                            <label class="radioButtonLabel">
                                <input type="radio" formControlName="DeviceRebootForm" [(ngModel)]="DeviceReboot"
                                    name="DeviceReboot" value="false" (change)="onRadioButtonClickRebootDevices(false)"
                                    [attr.disabled]="!canUserEditAlias ? true : null">
                            </label>
                        </div>
                    </td>
                </tr>

                <tr class="radioButtonTr">
                    <td class="text-dark td-title" i18n="@@aliasdetail_device_logs_permissions">Accesso log dispositivo
                        :</td>
                    <td class="radioButton">
                        <ng-container i18n="@@Enable">Abilita</ng-container>
                        <div id="radioButtonDiv">
                            <label class="radioButtonLabel">
                                <input type="radio" formControlName="DeviceViewLogsForm" [(ngModel)]="DeviceViewLogs"
                                    name="DeviceViewLogs" value="true"
                                    (change)="onRadioButtonClickDevicesViewLogs(true)"
                                    [attr.disabled]="!canUserEditAlias ? true : null">
                            </label>
                        </div>
                        <ng-container i18n="@@Disable">Disabilita</ng-container>
                        <div id="radioButtonDiv">
                            <label class="radioButtonLabel">
                                <input type="radio" formControlName="DeviceViewLogsForm" [(ngModel)]="DeviceViewLogs"
                                    name="DeviceViewLogs" value="false"
                                    (change)="onRadioButtonClickDevicesViewLogs(false)"
                                    [attr.disabled]="!canUserEditAlias ? true : null">
                            </label>
                        </div>
                    </td>
                </tr>

                <tr class="category-header">
                    <td colspan="2" class="text-bold" i18n="@@aliasdetail_category_automations">Automatismi</td>
                </tr>

                <tr class="radioButtonTr">
                    <td class="text-dark td-title" i18n="@@aliasdetail_execution_view_permissions">Visione automatismi :
                    </td>
                    <td class="radioButton">
                        <ng-container i18n="@@Enable">Abilita</ng-container>
                        <div id="radioButtonDiv">
                            <label class="radioButtonLabel">
                                <input type="radio" formControlName="ExecutionViewForm" [(ngModel)]="ExecutionView"
                                    name="ExecutionView" value="true" (change)="onRadioButtonClickViewExecutions(true)"
                                    [attr.disabled]="!canUserEditAlias ? true : null">
                            </label>
                        </div>
                        <ng-container i18n="@@Disable">Disabilita</ng-container>
                        <div id="radioButtonDiv">
                            <label class="radioButtonLabel">
                                <input type="radio" formControlName="ExecutionViewForm" [(ngModel)]="ExecutionView"
                                    name="ExecutionView" value="false"
                                    (change)="onRadioButtonClickViewExecutions(false)"
                                    [attr.disabled]="!canUserEditAlias ? true : null">
                            </label>
                        </div>
                    </td>
                </tr>

                <tr class="radioButtonTr">
                    <td class="text-dark td-title" i18n="@@aliasdetail_execution_edit_permissions">Modifica automatismi
                        :</td>
                    <td class="radioButton">
                        <ng-container i18n="@@Enable">Abilita</ng-container>
                        <div id="radioButtonDiv">
                            <label class="radioButtonLabel">
                                <input type="radio" formControlName="ExecutionEditForm" [(ngModel)]="ExecutionEdit"
                                    name="ExecutionEdit" value="true" (change)="onRadioButtonClickEditExecutions(true)"
                                    [attr.disabled]="!canUserEditAlias ? true : null">
                            </label>
                        </div>
                        <ng-container i18n="@@Disable">Disabilita</ng-container>
                        <div id="radioButtonDiv">
                            <label class="radioButtonLabel">
                                <input type="radio" formControlName="ExecutionEditForm" [(ngModel)]="ExecutionEdit"
                                    name="ExecutionEdit" value="false"
                                    (change)="onRadioButtonClickEditExecutions(false)"
                                    [attr.disabled]="!canUserEditAlias ? true : null">
                            </label>
                        </div>
                    </td>
                </tr>

                <tr class="category-header">
                    <td colspan="2" class="text-bold" i18n="@@aliasdetail_category_users">Abbonamenti</td>
                </tr>

                <tr class="radioButtonTr">
                    <td class="text-dark td-title" i18n="@@aliasdetail_user_view_permissions">Visione abbonamenti :</td>
                    <td class="radioButton">
                        <ng-container i18n="@@Enable">Abilita</ng-container>
                        <div id="radioButtonDiv">
                            <label class="radioButtonLabel">
                                <input type="radio" formControlName="UserViewForm" [(ngModel)]="UserView"
                                    name="UserView" value="true" (change)="onRadioButtonClickViewUsers(true)"
                                    [attr.disabled]="!canUserEditAlias ? true : null">
                            </label>
                        </div>
                        <ng-container i18n="@@Disable">Disabilita</ng-container>
                        <div id="radioButtonDiv">
                            <label class="radioButtonLabel">
                                <input type="radio" formControlName="UserViewForm" [(ngModel)]="UserView"
                                    name="UserView" value="false" (change)="onRadioButtonClickViewUsers(false)"
                                    [attr.disabled]="!canUserEditAlias ? true : null">
                            </label>
                        </div>
                    </td>
                </tr>

                <tr class="radioButtonTr">
                    <td class="text-dark td-title" i18n="@@aliasdetail_user_edit_permissions">Modifica abbonamenti :
                    </td>
                    <td class="radioButton">
                        <ng-container i18n="@@Enable">Abilita</ng-container>
                        <div id="radioButtonDiv">
                            <label class="radioButtonLabel">
                                <input type="radio" formControlName="UserEditForm" [(ngModel)]="UserEdit"
                                    name="UserEdit" value="true" (change)="onRadioButtonClickEditUsers(true)"
                                    [attr.disabled]="!canUserEditAlias ? true : null">
                            </label>
                        </div>
                        <ng-container i18n="@@Disable">Disabilita</ng-container>
                        <div id="radioButtonDiv">
                            <label class="radioButtonLabel">
                                <input type="radio" formControlName="UserEditForm" [(ngModel)]="UserEdit"
                                    name="UserEdit" value="false" (change)="onRadioButtonClickEditUsers(false)"
                                    [attr.disabled]="!canUserEditAlias ? true : null">
                            </label>
                        </div>
                    </td>
                </tr>

                <tr class="category-header">
                    <td colspan="2" class="text-bold" i18n="@@aliasdetail_category_groups">Gruppi</td>
                </tr>

                <tr class="radioButtonTr">
                    <td class="text-dark td-title" i18n="@@aliasdetail_group_view_permissions">Visione gruppi :</td>
                    <td class="radioButton">
                        <ng-container i18n="@@Enable">Abilita</ng-container>
                        <div id="radioButtonDiv">
                            <label class="radioButtonLabel">
                                <input type="radio" formControlName="GroupViewForm" [(ngModel)]="GroupView"
                                    name="GroupView" value="true" (change)="onRadioButtonClickViewGroups(true)"
                                    [attr.disabled]="!canUserEditAlias ? true : null">
                            </label>
                        </div>
                        <ng-container i18n="@@Disable">Disabilita</ng-container>
                        <div id="radioButtonDiv">
                            <label class="radioButtonLabel">
                                <input type="radio" formControlName="GroupViewForm" [(ngModel)]="GroupView"
                                    name="GroupView" value="false" (change)="onRadioButtonClickViewGroups(false)"
                                    [attr.disabled]="!canUserEditAlias ? true : null">
                            </label>
                        </div>
                    </td>
                </tr>

                <tr class="radioButtonTr">
                    <td class="text-dark td-title" i18n="@@aliasdetail_group_edit_permissions">Modifica gruppi :</td>
                    <td class="radioButton">
                        <ng-container i18n="@@Enable">Abilita</ng-container>
                        <div id="radioButtonDiv">
                            <label class="radioButtonLabel">
                                <input type="radio" formControlName="GroupEditForm" [(ngModel)]="GroupEdit"
                                    name="GroupEdit" value="true" (change)="onRadioButtonClickEditGroups(true)"
                                    [attr.disabled]="!canUserEditAlias ? true : null">
                            </label>
                        </div>
                        <ng-container i18n="@@Disable">Disabilita</ng-container>
                        <div id="radioButtonDiv">
                            <label class="radioButtonLabel">
                                <input type="radio" formControlName="GroupEditForm" [(ngModel)]="GroupEdit"
                                    name="GroupEdit" value="false" (change)="onRadioButtonClickEditGroups(false)"
                                    [attr.disabled]="!canUserEditAlias ? true : null">
                            </label>
                        </div>
                    </td>
                </tr>

                <tr class="category-header">
                    <td colspan="2" class="text-bold" i18n="@@aliasdetail_category_aliases">Operatori</td>
                </tr>

                <tr class="radioButtonTr">
                    <td class="text-dark td-title" i18n="@@aliasdetail_alias_view_permissions">Visione operatori :</td>
                    <td class="radioButton">
                        <ng-container i18n="@@Enable">Abilita</ng-container>
                        <div id="radioButtonDiv">
                            <label class="radioButtonLabel">
                                <input type="radio" formControlName="AliasViewForm" [(ngModel)]="AliasView"
                                    name="AliasView" value="true" (change)="onRadioButtonClickAliasView(true)"
                                    [attr.disabled]="!canUserEditAlias ? true : null">
                            </label>
                        </div>
                        <ng-container i18n="@@Disable">Disabilita</ng-container>
                        <div id="radioButtonDiv">
                            <label class="radioButtonLabel">
                                <input type="radio" formControlName="AliasViewForm" [(ngModel)]="AliasView"
                                    name="AliasView" value="false" (change)="onRadioButtonClickAliasView(false)"
                                    [attr.disabled]="!canUserEditAlias ? true : null">
                            </label>
                        </div>
                    </td>
                </tr>

                <tr class="radioButtonTr">
                    <td class="text-dark td-title" i18n="@@aliasdetail_alias_create_edit_permissions">Crea e modifica
                        operatori :</td>
                    <td class="radioButton">
                        <ng-container i18n="@@Enable">Abilita</ng-container>
                        <div id="radioButtonDiv">
                            <label class="radioButtonLabel">
                                <input type="radio" formControlName="AliasEditForm" [(ngModel)]="AliasEdit"
                                    name="AliasEdit" value="true" (change)="onRadioButtonClickEditAlias(true)"
                                    [attr.disabled]="!canUserEditAlias ? true : null">
                            </label>
                        </div>
                        <ng-container i18n="@@Disable">Disabilita</ng-container>
                        <div id="radioButtonDiv">
                            <label class="radioButtonLabel">
                                <input type="radio" formControlName="AliasEditForm" [(ngModel)]="AliasEdit"
                                    name="AliasEdit" value="false" (change)="onRadioButtonClickEditAlias(false)"
                                    [attr.disabled]="!canUserEditAlias ? true : null">
                            </label>
                        </div>
                    </td>
                </tr>

                <tr class="category-header">
                    <td colspan="2" class="text-bold" i18n="@@aliasdetail_category_operations_log">Registro operazioni
                    </td>
                </tr>

                <tr class="radioButtonTr">
                    <td class="text-dark td-title" i18n="@@aliasdetail_operation_log_view_permissions">Visione registro
                        operazioni :</td>
                    <td class="radioButton">
                        <ng-container i18n="@@Enable">Abilita</ng-container>
                        <div id="radioButtonDiv">
                            <label class="radioButtonLabel">
                                <input type="radio" formControlName="OperationViewForm" [(ngModel)]="OperationView"
                                    name="OperationView" value="true"
                                    (change)="onRadioButtonClickViewOperationsLog(true)"
                                    [attr.disabled]="!canUserEditAlias ? true : null">
                            </label>
                        </div>
                        <ng-container i18n="@@Disable">Disabilita</ng-container>
                        <div id="radioButtonDiv">
                            <label class="radioButtonLabel">
                                <input type="radio" formControlName="OperationViewForm" [(ngModel)]="OperationView"
                                    name="OperationView" value="false"
                                    (change)="onRadioButtonClickViewOperationsLog(false)"
                                    [attr.disabled]="!canUserEditAlias ? true : null">
                            </label>
                        </div>
                    </td>
                </tr>

                <tr class="category-header">
                    <td colspan="2" class="text-bold" i18n="@@aliasdetail_category_accept_requests">Richieste transito
                    </td>
                </tr>

                <tr class="radioButtonTr">
                    <td class="text-dark td-title" i18n="@@aliasdetail_accept_requests_permissions">Accettazione
                        richieste:</td>
                    <td class="radioButton">
                        <ng-container i18n="@@Enable">Abilita</ng-container>
                        <div id="radioButtonDiv">
                            <label class="radioButtonLabel">
                                <input type="radio" formControlName="AcceptRequestsForm" [(ngModel)]="AcceptRequests"
                                    name="AcceptRequests" value="true"
                                    (change)="onRadioButtonClickViewAcceptRequests(true)"
                                    [attr.disabled]="!canUserEditAlias ? true : null">
                            </label>
                        </div>
                        <ng-container i18n="@@Disable">Disabilita</ng-container>
                        <div id="radioButtonDiv">
                            <label class="radioButtonLabel">
                                <input type="radio" formControlName="AcceptRequestsForm" [(ngModel)]="AcceptRequests"
                                    name="AcceptRequests" value="false"
                                    (change)="onRadioButtonClickViewAcceptRequests(false)"
                                    [attr.disabled]="!canUserEditAlias ? true : null">
                            </label>
                        </div>
                    </td>
                </tr>


                <tr class="radioButtonTr">
                    <td class="text-dark td-title" i18n="@@aliasdetail_insert_requests_permissions">Inserimento
                        richieste:</td>
                    <td class="radioButton">
                        <ng-container i18n="@@Enable">Abilita</ng-container>
                        <div id="radioButtonDiv">
                            <label class="radioButtonLabel">
                                <input type="radio" formControlName="InsertRequestsForm" [(ngModel)]="InsertRequests"
                                    name="InsertRequests" value="true"
                                    (change)="onRadioButtonClickViewInsertRequests(true)"
                                    [attr.disabled]="!canUserEditAlias ? true : null">
                            </label>
                        </div>
                        <ng-container i18n="@@Disable">Disabilita</ng-container>
                        <div id="radioButtonDiv">
                            <label class="radioButtonLabel">
                                <input type="radio" formControlName="InsertRequestsForm" [(ngModel)]="InsertRequests"
                                    name="InsertRequests" value="false"
                                    (change)="onRadioButtonClickViewInsertRequests(false)"
                                    [attr.disabled]="!canUserEditAlias ? true : null">
                            </label>
                        </div>
                    </td>
                </tr>

                <tr class="radioButtonTr">
                    <td class="text-dark td-title" i18n="@@aliasdetail_manage_permission_types">Gestione tipologie di permessi:</td>
                    <td class="radioButton">
                        <ng-container i18n="@@Enable">Abilita</ng-container>
                        <div id="radioButtonDiv">
                            <label class="radioButtonLabel">
                                <input type="radio" formControlName="ManageRequestTypesForm"
                                    [(ngModel)]="ManageRequestTypes" name="ManageRequestTypes" value="true"
                                    (change)="onRadioButtonClickViewManageRequestTypes(true)"
                                    [attr.disabled]="!canUserEditAlias ? true : null">
                            </label>
                        </div>
                        <ng-container i18n="@@Disable">Disabilita</ng-container>
                        <div id="radioButtonDiv">
                            <label class="radioButtonLabel">
                                <input type="radio" formControlName="ManageRequestTypesForm"
                                    [(ngModel)]="ManageRequestTypes" name="ManageRequestTypes" value="false"
                                    (change)="onRadioButtonClickViewManageRequestTypes(false)"
                                    [attr.disabled]="!canUserEditAlias ? true : null">
                            </label>
                        </div>
                    </td>
                </tr>


                <tr class="radioButtonTr">
                    <td class="text-dark td-title" i18n="@@aliasdetail_showinlist_requests_permissions">Mostra in
                        elenco:</td>
                    <td class="radioButton">
                        <ng-container i18n="@@Enable">Abilita</ng-container>
                        <div id="radioButtonDiv">
                            <label class="radioButtonLabel">
                                <input type="radio" formControlName="ShowInListRequestsForm"
                                    [(ngModel)]="ShowInListRequests" name="ShowInListRequests" value="true"
                                    (change)="onRadioButtonClickViewShowInListRequests(true)"
                                    [attr.disabled]="!canUserEditAlias ? true : null">
                            </label>
                        </div>
                        <ng-container i18n="@@Disable">Disabilita</ng-container>
                        <div id="radioButtonDiv">
                            <label class="radioButtonLabel">
                                <input type="radio" formControlName="ShowInListRequestsForm"
                                    [(ngModel)]="ShowInListRequests" name="ShowInListRequests" value="false"
                                    (change)="onRadioButtonClickViewShowInListRequests(false)"
                                    [attr.disabled]="!canUserEditAlias ? true : null">
                            </label>
                        </div>
                    </td>
                </tr>

            </table>
        </form>


    </div>

    <div *ngIf="canUserEditAlias" class="margin-top-30">

        <a (click)="saveAliasFeatures()" class="button user-add-button">
            <ng-container i18n="@@aliasdetail_save">Salva</ng-container>
            <span>
                <fa-icon icon="save"></fa-icon>
            </span>
        </a>

    </div>



</section>

<app-loading-screen #aliasloader></app-loading-screen>